import { useState } from "react";
import { useData } from "../store/DataProvider";
import { isTestEnvironment, PRODUCTION_URL } from "../services/environment";

const DISMISSED_KEY = "namjing-test-notice-dismissed";

const wasDismissed = () => {
    try {
        return sessionStorage.getItem(DISMISSED_KEY) === "1";
    } catch {
        /* private browsing can refuse sessionStorage; showing the notice again
           is the harmless failure */
        return false;
    }
};

const remember = () => {
    try {
        sessionStorage.setItem(DISMISSED_KEY, "1");
    } catch {
        /* nothing to do -- the notice simply shows again next time */
    }
};

/* Shown once per browser session, on the first screen after logging in to
   anything that is not production. Session-scoped rather than permanent: the
   point is to catch someone who has forgotten which system they are on, and a
   dismissal that lasted forever would stop doing that. */
const TestNotice = () => {
    const { user } = useData();
    const [dismissed, setDismissed] = useState(wasDismissed);

    const loggedIn = Boolean(user && user._id);
    if (!isTestEnvironment() || !loggedIn || dismissed) {
        return null;
    }

    const onContinue = () => {
        remember();
        setDismissed(true);
    };

    return (
        <div className="test-notice-overlay">
            <div className="test-notice">
                <h2 className="test-notice-heading">
                    You are logging into Namjing Mai Jing &mdash; testing only!
                </h2>
                <p className="test-notice-body">
                    This is a copy of the salon's system for trying things out.
                    Sales, expenses and staff changes made here are{" "}
                    <strong>not saved</strong> to the real records, and anything
                    you delete here is not really deleted.
                </p>
                <p className="test-notice-body">
                    The real till is at <strong>pos.namjing.xyz</strong>.
                </p>
                <div className="test-notice-buttons">
                    <button
                        type="button"
                        className="test-notice-continue"
                        onClick={onContinue}
                        autoFocus={true}
                    >
                        Continue
                    </button>
                    <a className="test-notice-leave" href={PRODUCTION_URL}>
                        Go to Namjing
                    </a>
                </div>
            </div>
        </div>
    );
};

export default TestNotice;
